import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Tab } from '@material-ui/core';

var PageTab = function PageTab(_ref) {
  var caption = _ref.caption,
      error = _ref.error,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, ["caption", "error", "classes"]);

  var style = error ? {
    root: classes.errorTab,
    wrapper: classes.wrapper,
    selected: classes.selectedErrorTab
  } : {
    root: classes.tab,
    wrapper: classes.wrapper,
    selected: classes.selectedTab
  };
  return React.createElement(Tab, Object.assign({
    label: caption,
    title: caption,
    classes: style
  }, props));
};

var styles = function styles() {
  var _tab, _errorTab;

  return createStyles({
    wrapper: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block'
    },
    tab: (_tab = {
      zIndex: 1,
      textTransform: 'uppercase',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      borderBottom: '2px solid transparent',

      /** placed over tabIndicator */
      color: 'black',
      opacity: 0.6,
      marginLeft: 2,
      marginRight: 2,
      minWidth: 'initial',
      maxWidth: 400
    }, _defineProperty(_tab, "fontWeight", 800), _defineProperty(_tab, '&:hover', {
      opacity: 0.8
    }), _tab),
    errorTab: (_errorTab = {
      zIndex: 1,
      textTransform: 'uppercase',
      fontSize: 'inherit',
      fontWeight: 'inherit',

      /** placed over tabIndicator */
      opacity: 0.6,
      borderBottom: '2px solid #f44336',
      marginLeft: 2,
      marginRight: 2,
      minWidth: 'initial',
      maxWidth: 400
    }, _defineProperty(_errorTab, "fontWeight", 800), _defineProperty(_errorTab, '&:hover', {
      opacity: 0.8
    }), _errorTab),
    selectedTab: {
      fontWeight: 800,
      color: 'black',
      opacity: 1,
      borderBottom: '2px solid black'
    },
    selectedErrorTab: {
      fontWeight: 800,
      color: 'black',
      opacity: 1,
      borderBottom: '2px solid #f44336'
    }
  });
};

export default withStyles(styles, {
  name: 'ECPageTab'
})(PageTab);